$(function() {
  $(document).on('keyup', '.money', function() {
    var div, input, input_parent, value;
    input = $(this);
    value = input.val();
    if (value.length === 0){
      value = 0
    }
    div = '';
    div += '<div>';
    div += '$ ' + Intl.NumberFormat().format(parseFloat(value))
    div += '</div>';
    input_parent = input.parent('div');
    input_parent.find('div').remove();
    input_parent.append(div);
  });
});